export const ExpenseTableTypes = {
    GET_EXP_TABLE:'GET_EXP_TABLE',
}